module.exports = __webpack_public_path__ + "static/media/nahuel_molina.0c52ae22.jpg";